import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { createLocalStorageStateHook } from 'use-local-storage-state';

import { selectCurrentUser } from 'selectors/user';

// Store a map of { [userId]: val } for users who dismissed a UI element.
// Returns a tuple of [valueForUser, setValueForUser], following a shape
// similar to useState
export function useStoredStateForUser(key) {
  const [value, setValue] = createLocalStorageStateHook(key)();
  const currentUserId = useSelector(selectCurrentUser)?.id;

  return [
    value?.[currentUserId],
    useCallback(
      (val = true) => {
        setValue({ ...value, [currentUserId]: val });
      },
      [value, setValue, currentUserId]
    ),
  ];
}

// Takes in a map of:
//    manualDismissed: Boolean,
//    timeDismissal: String or Boolean (Unix timestamp or true if already time-dismissed)
//    setTimedDismissal: (a hook to set a new timeDismissal or toggle the element as time-dismissed)
// Returns a boolean of whether or not to dimiss element
export function useTimedDismissal({
  manualDismissed,
  timeDismissal,
  setTimedDismissal,
}) {
  if (manualDismissed || timeDismissal === true) {
    return true;
  }

  if (typeof timeDismissal === 'undefined') {
    return false;
  }

  const now = Date.now();

  if (now > Number(timeDismissal)) {
    setTimedDismissal(true);

    return true;
  }

  return false;
}
